export * from './FAQLink'
export { default } from './FAQLink'
